import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

//Pages
import Home from './pages/Home'
import SignUp from './pages/SignUp'
//Components
import NavbarUi from './components/NavbarUi'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/inscripciones',
    element: <SignUp />
  }
])

function App() {
  return (
    <div className='App'>
      <div className='content'>
        <NavbarUi />
        <RouterProvider router={router} />
      </div>
    </div>
  )
}

export default App
